import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { BulkCustomersDownloadSaga, BulkCustomersFileCheckerRemarkSaga, BulkCustomersFileMakerRemarkSaga, bulkCustomersType, BulkCustomersVersionSaga, fetchBulkCustomersDetailSaga, fetchBulkCustomersSaga, uploadBulkCustomersFileSaga } from "./types";
import { approveBulkCustomersFileApi, BulkCustomersPublishApi, deDuplicateBulkCustomersFileCheckApi, deleteBulkCustomersFileApi, downloadBulkCustomersFileApi, fetchBulkCustomersApi, fetchBulkCustomersDetailApi, fetchBulkCustomersVersionApi, fetchBulkFileSpecificCustomersApi, rejectBulkCustomersFileApi, uploadBulkCustomersFileApi } from "./api";

function* uploadBulkCustomers({ payload, type }: uploadBulkCustomersFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkCustomersFileApi, payload);

        yield put({
            type: bulkCustomersType.UPLOAD_BULK_CUSTOMERS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.UPLOAD_BULK_CUSTOMERS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkCustomers({ payload, type }: fetchBulkCustomersSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomersApi, payload);

        yield put({
            type: bulkCustomersType.FETCH_BULK_CUSTOMERS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.FETCH_BULK_CUSTOMERS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkCustomersDetail({ payload, type }: fetchBulkCustomersDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomersDetailApi, payload);

        yield put({
            type: bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}

function* BulkCustomersVersion({ payload, type }: BulkCustomersVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomersVersionApi, payload);

        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_VERSION_ERROR,
            payload: { error: error }
        });
    }
}

function* BulkCustomersPublish({ payload, type }: BulkCustomersFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(BulkCustomersPublishApi, payload);
        console.log("response publish ", response)
        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_PUBLISH_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_PUBLISH_ERROR,
            payload: { error: error }
        });
    }
}

function* downloadBulkCustomersFile({ payload, type }: BulkCustomersDownloadSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkCustomersFileApi, payload);
        const file = payload.downloadURL.split("/")
        const responseData = {
            fileBlob: response.data,
            fileName: file[file.length - 1]
        }
        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkFileSpecificCustomers({ payload, type }: BulkCustomersVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificCustomersApi, payload);

        yield put({
            type: bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_ERROR,
            payload: { error: error }
        });
    }
}

function* approveBulkCustomersFile({ payload, type }: BulkCustomersFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkCustomersFileApi, payload);
        console.log("response", response)
        yield put({
            type: bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}


function* rejectBulkCustomersFile({ payload, type }: BulkCustomersFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkCustomersFileApi, payload);

        yield put({
            type: bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* deDuplicateBulkCustomersFileCheck({ payload, type }: fetchBulkCustomersDetailSaga): SagaIterator {
    try {
        const response = yield call(deDuplicateBulkCustomersFileCheckApi, payload);

        yield put({
            type: bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_ERROR,
            payload: { error: error }
        });
    }
}

function* deleteBulkCustomersFile({ payload, type }: fetchBulkCustomersDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkCustomersFileApi, payload);
        yield put({
            type: bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchUploadBulkCustomers() {
    yield takeEvery(bulkCustomersType.UPLOAD_BULK_CUSTOMERS, uploadBulkCustomers);
}

export function* watchFetchBulkCustomers() {
    yield takeEvery(bulkCustomersType.FETCH_BULK_CUSTOMERS, fetchBulkCustomers);
}

export function* watchFetchBulkCustomersDetail() {
    yield takeEvery(bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL, fetchBulkCustomersDetail);
}

export function* watchBulkCustomersVersion() {
    yield takeEvery(bulkCustomersType.BULK_CUSTOMERS_VERSION, BulkCustomersVersion);
}

export function* watchBulkCustomersPublish() {
    yield takeEvery(bulkCustomersType.BULK_CUSTOMERS_PUBLISH, BulkCustomersPublish);
}

export function* watchDownloadBulkCustomers() {
    yield takeEvery(bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD, downloadBulkCustomersFile);
}

export function* watchFetchBulkFileSpecificCustomers() {
    yield takeEvery(bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS, fetchBulkFileSpecificCustomers);
}

export function* watchApproveBulkCustomersPublish() {
    yield takeEvery(bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE, approveBulkCustomersFile);
}

export function* watchRejectBulkCustomersPublish() {
    yield takeEvery(bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE, rejectBulkCustomersFile);
}

export function* watchDeDuplicateBulkCustomersFileCheck() {
    yield takeEvery(bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK, deDuplicateBulkCustomersFileCheck);
}

export function* watchDeleteBulkCustomersFile() {
    yield takeEvery(bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE, deleteBulkCustomersFile);
}


function* BulkCustomerSaga() {
    yield all([
        fork(watchUploadBulkCustomers),
        fork(watchFetchBulkCustomers),
        fork(watchFetchBulkCustomersDetail),
        fork(watchBulkCustomersVersion),
        fork(watchBulkCustomersPublish),
        fork(watchDownloadBulkCustomers),
        fork(watchFetchBulkFileSpecificCustomers),
        fork(watchApproveBulkCustomersPublish),
        fork(watchRejectBulkCustomersPublish),
        fork(watchDeDuplicateBulkCustomersFileCheck),
        fork(watchDeleteBulkCustomersFile)
    ]);
}

export default BulkCustomerSaga;